// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MediaQuery from 'react-responsive';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import { getPostcode, getAddresses } from '../store/selectors';
import * as searchAddressActions from '../store/actions';
import { getAddress, getProfile, getSuccess } from '../../MyProfile/store/selectors';
import * as profileActions from '../../MyProfile/store/actions';
import {
  Description,
  Input,
  Button,
  // SearchBar
  SearchInput,
} from '../../../../../../../components';
import ProfileMenuResriction from '../../ProfileMenuResriction';
import styles from './styles';

class Address extends Component {
  state = { isTradeCustomer: JSON.parse(localStorage.getItem('TradeCustomer')) }

  static propTypes = {
    classes: PropTypes.object,
    requestAddress: PropTypes.func,
    address: PropTypes.object,
    changeFieldAddress: PropTypes.func,
    profile: PropTypes.object,
    requestProfileEdit: PropTypes.func,
    success: PropTypes.object,
    postcode: PropTypes.string,
    changeField: PropTypes.func,
    searchAddress: PropTypes.func,
    addresses: PropTypes.array,
    requestSelectedAddress: PropTypes.func,
    resetErrorsAndSuccess: PropTypes.func,
    resetSearchInput: PropTypes.func,
  };

  static defaultProps = {
    classes: {},
    address: {},
    profile: {},
    requestAddress: () => { },
    changeFieldAddress: () => { },
    requestProfileEdit: () => { },
    changeField: () => { },
    searchAddress: () => { },
    requestSelectedAddress: () => { },
    success: {},
    postcode: null,
    addresses: [],
    resetErrorsAndSuccess: () => { },
    resetSearchInput: () => { },
  };

  onSubmit = () => {
    const id = localStorage.getItem('loggedID');
    const token = localStorage.getItem('token');
    this.props.requestProfileEdit(this.props.profile, id, token, { page: 'address' });
  }

  componentDidMount() {
    const { requestAddress } = this.props;
    const { isTradeCustomer } = this.state;
    if (!isTradeCustomer) {
      const id = localStorage.getItem('loggedID');
      const token = localStorage.getItem('token');
      requestAddress(id, token);
    }
  }

  onChangeInput = (value, name) => {
    this.props.changeFieldAddress(value, name);
  };

  componentWillUnmount() {
    this.props.resetErrorsAndSuccess();
    this.props.resetSearchInput();
  }

  render() {
    const { classes } = this.props;
    const { isTradeCustomer } = this.state;

    return isTradeCustomer
      ? <ProfileMenuResriction />
      : (
        <div className={classes.root}>
          <form className={classes.form} autoComplete={'off'}>
            <MediaQuery maxWidth={549}>
              <Description text={'Address'} />
            </MediaQuery>
            {/* <SearchBar
              changeField={this.props.changeField}
              onChange={this.onChangeInput}
              postcode={this.props.postcode}
            /> */}
            <SearchInput
              changeField={this.props.changeField}
              searchAddress={this.props.searchAddress}
              requestSelectedAddress={this.props.requestSelectedAddress}
              postcode={this.props.postcode}
              addresses={this.props.addresses}
            />
            <Input
              label={'Postcode:'}
              name={'Postcode'}
              value={this.props.address.Postcode}
              onChange={this.onChangeInput}
            />
            <Input
              label={'Address line 1:'}
              name={'AddressLine1'}
              value={this.props.address.AddressLine1}
              onChange={this.onChangeInput}
            />
            <Input
              label={'Address line 2:'}
              name={'AddressLine2'}
              value={this.props.address.AddressLine2}
              onChange={this.onChangeInput}
            />
            <Input
              label={'Town:'}
              name={'Town'}
              value={this.props.address.Town}
              onChange={this.onChangeInput}
            />
            <Input
              label={'County:'}
              name={'County'}
              value={this.props.address.County}
              onChange={this.onChangeInput}
            />
            <h6 className={classNames(classes.successText,
              !this.props.success.status ? classes.rejectedColor : '')}
            >
              {this.props.success.address}
            </h6>
            <Button
              text={'update'}
              style={classes.submitButtonStyle}
              onPress={this.onSubmit}
            />
          </form>
        </div>
      );
  }
}

const mapStateToProps = (state) => {
  return {
    address: getAddress(state),
    profile: getProfile(state),
    success: getSuccess(state),
    postcode: getPostcode(state),
    addresses: getAddresses(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    requestAddress: (id, token) => dispatch(profileActions.requestProfile(id, token)),
    changeFieldAddress: (value, name) => dispatch(profileActions.changeFieldAddress(value, name)),
    changeField: (value, name) => dispatch(searchAddressActions.changeField(value, name)),
    requestProfileEdit: (data, id, token, page) => dispatch(profileActions
      .requestProfileEdit(data, id, token, page)),
    searchAddress: data => dispatch(searchAddressActions.requestAddressSearch(data)),
    requestSelectedAddress: data => dispatch(searchAddressActions.requestSelectedAddress(data)),
    resetErrorsAndSuccess: () => dispatch(profileActions.resetErrorsAndSuccess()),
    resetSearchInput: () => dispatch(searchAddressActions.resetSearchInput())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Address));
